import * as types from './actionTypes';

export function setMerchantDetailsAction(merchantDetails) {
  return { type: types.SET_MERCHANT_DETAILS, merchantDetails };
}